import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryProjects } from "./routeType";

import type { IPickDelete } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryProjects } from "@/api/members/laboratories/projects/getAll";
import { useGetMemberLaboratoryProject } from "@/api/members/laboratories/projects/get";

const { getPath } = getApi("members.laboratories.projects.delete");

type IExtractedRouteType = ILaboratoryProjects["laboratoryProjectSingleDelete"];

export type IDeleteMemberLaboratoryProject = IPickDelete<IExtractedRouteType>;

const deleteMemberLaboratoryProject: MutationFunction<
  IDeleteMemberLaboratoryProject["response"],
  IDeleteMemberLaboratoryProject["variables"]
> = ({ labId, projectId }) => {
  return axiosClient.delete(getPath({ labId, projectId }));
};

export const useDeleteMemberLaboratoryProject = createMutation({
  mutationFn: deleteMemberLaboratoryProject,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryProject.getKey({ labId }),
    });
  },
});
